var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Dynamic SO',
        to: '/dynamic-so'
      }],
      "title": "All Dynamic SO"
    }
  }), _c('div', {
    staticClass: "bg-white my-3"
  }, [_c('div', {
    staticClass: "flex justify-between bg-white py-3 px-4"
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "relative"
  }, [_c('svg', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400",
    attrs: {
      "width": "20",
      "height": "20",
      "fill": "currentColor",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 2a8 8 0 016.32 12.906l4.387 4.387a1 1 0 01-1.415 1.415l-4.387-4.387A8 8 0 1110 2zm0 2a6 6 0 100 12 6 6 0 000-12z"
    }
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchForm,
      expression: "searchForm"
    }],
    staticClass: "p-2.5 pl-5 w-96 text-sm text not-italic border rounded-lg",
    attrs: {
      "placeholder": "Search by Ticket No. and SO No.."
    },
    domProps: {
      "value": _vm.searchForm
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.searchForm = $event.target.value;
      }, _vm.onInput],
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchData.apply(null, arguments);
      }
    }
  }), _vm.searchForm ? _c('button', {
    staticClass: "absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500 hover:text-gray-700",
    attrs: {
      "title": "Clear search"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" ✕ ")]) : _vm._e()])])]), _c('t-dropdown', {
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function (_ref) {
        var mousedownHandler = _ref.mousedownHandler,
          focusHandler = _ref.focusHandler,
          blurHandler = _ref.blurHandler,
          keydownHandler = _ref.keydownHandler;
        return _c('div', {
          staticClass: "flex"
        }, [_c('button', {
          staticClass: "flex items-center relative justify-center h-10 px-3 py-2.5 text-gray-500 bg-white border border-gray-400 rounded-lg",
          on: {
            "mousedown": mousedownHandler,
            "focus": focusHandler,
            "blur": blurHandler,
            "keydown": keydownHandler
          }
        }, [_c('svg', {
          staticClass: "w-4 h-4 mr-1 text-gray-600 dark:text-white",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M5.05 3C3.291 3 2.352 5.024 3.51 6.317l5.422 6.059v4.874c0 .472.227.917.613 1.2l3.069 2.25c1.01.742 2.454.036 2.454-1.2v-7.124l5.422-6.059C21.647 5.024 20.708 3 18.95 3H5.05Z"
          }
        })]), _vm._v(" Filter "), _c('svg', {
          staticClass: "w-5 h-5 ml-1 text-gray-600 fill-current",
          attrs: {
            "viewBox": "0 0 20 20",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('polygon', {
          attrs: {
            "points": "9.29289322 12.9497475 10 13.6568542 15.6568542 8 14.2426407 6.58578644 10 10.8284271 5.75735931 6.58578644 4.34314575 8"
          }
        })]), _vm.dataBadge ? _c('div', {
          staticClass: "rounded-full w-5 h-5 bg-red-600 absolute -top-2 -right-2 text-white text-xs flex justify-center items-center"
        }, [_vm._v(" " + _vm._s(_vm.dataBadge) + " ")]) : _vm._e()])]);
      }
    }, {
      key: "default",
      fn: function (_ref2) {
        var hide = _ref2.hide,
          blurHandler = _ref2.blurHandler;
        return _c('div', {
          staticClass: "w-custom bg-white absolute -right-2 pt-2 pb-3 border rounded-lg"
        }, [_c('div', {
          staticClass: "block w-full px-4 py-2 text-sm text-gray-500 transition duration-150 ease-in-out focus:outline-none focus:bg-gray-100",
          attrs: {
            "role": "menuitem"
          }
        }, [_c('div', {
          staticClass: "flex justify-between mb-3 mt-2"
        }, [_c('div', [_vm._v("Filter")]), _c('div', {
          on: {
            "click": hide
          }
        }, [_c('svg', {
          staticClass: "w-4 h-4 text-gray-800 dark:text-white cursor-pointer",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "none",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "stroke": "currentColor",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            "d": "M6 18 17.94 6M18 18 6.06 6"
          }
        })])])]), _c('div', {
          staticClass: "block w-full mb-2"
        }, [_vm._v("Order Date")]), _c('div', {
          staticClass: "grid gap-4 grid-cols-2"
        }, [_c('div', [_c('DatetimeCustom', {
          attrs: {
            "timeDate": false,
            "label": 'Start Date'
          },
          on: {
            "blur": blurHandler
          },
          model: {
            value: _vm.start_date,
            callback: function ($$v) {
              _vm.start_date = $$v;
            },
            expression: "start_date"
          }
        })], 1), _c('div', [_c('DatetimeCustom', {
          attrs: {
            "timeDate": false,
            "label": 'End Date'
          },
          on: {
            "blur": blurHandler
          },
          model: {
            value: _vm.end_date,
            callback: function ($$v) {
              _vm.end_date = $$v;
            },
            expression: "end_date"
          }
        })], 1), _c('div', [_c('label', {
          staticClass: "text-gray-600 font-semibold mb-3 mt-2"
        }, [_vm._v("Offer Type")]), _c('FilterComponent', {
          attrs: {
            "options": _vm.offerTypeOptions,
            "defaultText": 'Select Type Option'
          },
          model: {
            value: _vm.offerType,
            callback: function ($$v) {
              _vm.offerType = $$v;
            },
            expression: "offerType"
          }
        })], 1), _c('div', [_c('label', {
          staticClass: "text-gray-600 font-semibold mb-3 mt-2"
        }, [_vm._v("Status")]), _c('FilterComponent', {
          attrs: {
            "options": _vm.statusOptions,
            "defaultText": 'Select Status'
          },
          model: {
            value: _vm.statusSo,
            callback: function ($$v) {
              _vm.statusSo = $$v;
            },
            expression: "statusSo"
          }
        })], 1)]), _c('div', {
          staticClass: "flex justify-between m"
        }), _c('div', {
          staticClass: "mt-3"
        }, [_c('button', {
          staticClass: "border bg-blue-500 px-4 py-2 text-white rounded-lg",
          on: {
            "click": function ($event) {
              return _vm.fetchData();
            },
            "blur": blurHandler
          }
        }, [_vm._v(" Filter ")]), _c('button', {
          staticClass: "border bg-white text-gray-500 px-4 py-2 rounded-lg ml-2",
          on: {
            "click": function ($event) {
              return _vm.reset();
            },
            "blur": blurHandler
          }
        }, [_vm._v("Reset")])])])]);
      }
    }])
  })], 1), _c('div', [_c('div', {
    staticClass: "text-left mt-0 bg-white"
  }, [_c('t-table', {
    staticClass: "shadow-none",
    attrs: {
      "data": _vm.items
    },
    scopedSlots: _vm._u([_vm.isLoading ? {
      key: "tbody",
      fn: function (props) {
        return [_c('tbody', {
          class: props.tbodyClass
        }, [_c('tr', {
          class: [props.trClass, 'text-center']
        }, [_c('td', {
          class: props.tdClass,
          attrs: {
            "colspan": "15"
          }
        }, [_c('div', {
          staticClass: "flex justify-center items-center h-72",
          attrs: {
            "role": "status"
          }
        }, [_c('svg', {
          staticClass: "w-8 h-8 text-gray-200 text-center animate-spin dark:text-gray-600 fill-blue-600",
          attrs: {
            "aria-hidden": "true",
            "viewBox": "0 0 100 101",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "d": "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            "fill": "currentColor"
          }
        }), _c('path', {
          attrs: {
            "d": "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            "fill": "currentFill"
          }
        })]), _c('span', {
          staticClass: "sr-only text-center items-center"
        }, [_vm._v("Loading...")])])])])])];
      }
    } : !_vm.items.length ? {
      key: "tbody",
      fn: function (props) {
        return [_c('tbody', {
          class: props.tbodyClass
        }, [_c('tr', {
          class: [props.trClass, 'text-center']
        }, [_c('td', {
          class: props.tdClass,
          attrs: {
            "colspan": "15"
          }
        }, [_c('div', {
          staticClass: "flex-col items-center justify-center flex-nowrap flex h-96"
        }, [_c('svg', {
          attrs: {
            "width": "35",
            "height": "35",
            "viewBox": "0 0 64 64",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "d": "M36.014 19.1452L29.5936 25.5656L36.014 31.986C36.524 32.5141 36.8063 33.2214 36.7999 33.9555C36.7935 34.6897 36.499 35.3919 35.9799 35.9111C35.4608 36.4302 34.7585 36.7247 34.0243 36.7311C33.2902 36.7375 32.5829 36.4552 32.0548 35.9452L25.6344 29.5248L19.214 35.9452C18.9557 36.2126 18.6467 36.4259 18.3051 36.5727C17.9635 36.7194 17.5961 36.7967 17.2243 36.7999C16.8525 36.8031 16.4838 36.7323 16.1397 36.5915C15.7956 36.4507 15.483 36.2428 15.2201 35.9799C14.9572 35.717 14.7493 35.4044 14.6085 35.0603C14.4677 34.7162 14.3969 34.3475 14.4001 33.9757C14.4033 33.6039 14.4806 33.2365 14.6273 32.8949C14.7741 32.5532 14.9874 32.2443 15.2548 31.986L21.6752 25.5656L15.2548 19.1452C14.7448 18.6171 14.4625 17.9098 14.4689 17.1757C14.4753 16.4415 14.7698 15.7392 15.2889 15.2201C15.8081 14.701 16.5103 14.4065 17.2445 14.4001C17.9786 14.3937 18.6859 14.6759 19.214 15.186L25.6344 21.6064L32.0548 15.186C32.5829 14.6759 33.2902 14.3937 34.0243 14.4001C34.7585 14.4065 35.4608 14.701 35.9799 15.2201C36.499 15.7392 36.7935 16.4415 36.7999 17.1757C36.8063 17.9098 36.524 18.6171 36.014 19.1452Z",
            "fill": "#4B5563"
          }
        }), _c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            "d": "M11.3775 46.8856C15.5875 49.6986 20.5371 51.2 25.6003 51.2C32.3876 51.1924 38.8947 48.4928 43.694 43.6935C48.4934 38.8942 51.193 32.3872 51.2006 25.6C51.2006 20.5368 49.6992 15.5873 46.8862 11.3774C44.0732 7.16751 40.075 3.8863 35.3971 1.94869C30.7193 0.011092 25.5719 -0.495873 20.6059 0.491908C15.64 1.47969 11.0784 3.91785 7.49817 7.49807C3.9179 11.0783 1.47971 15.6398 0.491914 20.6057C-0.495879 25.5716 0.0110922 30.7189 1.94872 35.3967C3.88634 40.0745 7.1676 44.0726 11.3775 46.8856ZM14.9332 9.63579C18.0907 7.52607 21.8029 6.40001 25.6003 6.40001C30.691 6.40509 35.5717 8.42957 39.1713 12.0292C42.7709 15.6288 44.7955 20.5094 44.8005 25.6C44.8005 29.3974 43.6745 33.1095 41.5647 36.2669C39.455 39.4244 36.4563 41.8853 32.9479 43.3385C29.4395 44.7917 25.579 45.1719 21.8545 44.4311C18.1301 43.6902 14.7089 41.8616 12.0237 39.1764C9.3385 36.4913 7.50986 33.0702 6.76901 29.3457C6.02817 25.6213 6.4084 21.7608 7.86162 18.2525C9.31484 14.7441 11.7758 11.7455 14.9332 9.63579Z",
            "fill": "#4B5563"
          }
        }), _c('path', {
          attrs: {
            "d": "M58.5382 63.0624C59.1382 63.6626 59.952 63.9998 60.8006 64C61.4335 63.9999 62.052 63.8121 62.5781 63.4605C63.1043 63.1089 63.5143 62.6091 63.7565 62.0245C63.9986 61.4399 64.062 60.7965 63.9385 60.1759C63.8151 59.5552 63.5105 58.9851 63.0631 58.5376L50.2629 45.7376C49.6594 45.1547 48.8511 44.8322 48.012 44.8394C47.173 44.8467 46.3704 45.1833 45.7771 45.7766C45.1837 46.3699 44.8472 47.1725 44.8399 48.0115C44.8326 48.8506 45.1552 49.6589 45.7381 50.2624L58.5382 63.0624Z",
            "fill": "#4B5563"
          }
        })]), _c('h4', {
          staticClass: "text-base text-gray-600 mb-0"
        }, [_vm._v("No results found")]), _c('p', {
          staticClass: "text-sm text-gray-500"
        }, [_vm._v("Change your keyword or filter")])])])])])];
      }
    } : null, {
      key: "thead",
      fn: function (props) {
        return [_c('thead', {
          staticClass: "sticky-header"
        }, [_c('tr', [_c('th', {
          class: props.thClass
        }, [_vm._v("No")]), _c('th', {
          class: props.thClass
        }, [_vm._v("Ticket No.")]), _c('th', {
          class: props.thClass
        }, [_vm._v("SO No.")]), _c('th', {
          class: props.thClass
        }, [_vm._v("SO Period")]), _c('th', {
          class: props.thClass
        }, [_vm._v("Offer Type")]), _c('th', {
          class: props.thClass
        }, [_vm._v("Status")]), _c('th', {
          class: props.thClass
        }, [_vm._v("Message")]), _c('th', {
          class: props.thClass
        }, [_c('div', {
          staticClass: "flex items-center cursor-pointer",
          on: {
            "click": function ($event) {
              return _vm.sortBy('created');
            }
          }
        }, [_vm._v(" Created Date "), _c('span', {
          attrs: {
            "href": "#"
          }
        }, [_c('svg', {
          staticClass: "w-3 h-3 ms-1.5",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
          }
        })])])])]), _c('th', {
          class: props.thClass
        }, [_c('div', {
          staticClass: "flex items-center cursor-pointer",
          on: {
            "click": function ($event) {
              return _vm.sortBy('modified');
            }
          }
        }, [_vm._v(" Last Modified "), _c('span', {
          attrs: {
            "href": "#"
          }
        }, [_c('svg', {
          staticClass: "w-3 h-3 ms-1.5",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
          }
        })])])])]), _c('th', {
          class: props.thClass
        })])])];
      }
    }, {
      key: "row",
      fn: function (props) {
        var _props$row, _props$row2, _props$row3, _props$row4, _props$row5, _props$row6, _props$row7, _props$row8, _props$row9, _props$row10, _props$row11, _props$row12, _props$row13, _props$row14, _props$row15;
        return [_c('tr', {
          staticClass: "text-gray-500"
        }, [_c('td', {
          staticClass: "text-center",
          class: props.tdClass
        }, [_vm._v(" " + _vm._s((_vm.currentPage - 1) * _vm.perPage + props.rowIndex + 1) + " ")]), _c('td', {
          staticClass: "cursor-pointer text-left",
          class: props.tdClass
        }, [_vm._v(" " + _vm._s((_props$row = props.row) !== null && _props$row !== void 0 && _props$row.ticket_number ? (_props$row2 = props.row) === null || _props$row2 === void 0 ? void 0 : _props$row2.ticket_number : '-') + " ")]), _c('td', {
          attrs: {
            "clas": props.tdClass
          }
        }, [_vm._v(" " + _vm._s((_props$row3 = props.row) !== null && _props$row3 !== void 0 && _props$row3.so_number ? (_props$row4 = props.row) === null || _props$row4 === void 0 ? void 0 : _props$row4.so_number : '-') + " ")]), _c('td', {
          attrs: {
            "clas": props.tdClass
          }
        }, [_vm._v(" " + _vm._s((_props$row5 = props.row) !== null && _props$row5 !== void 0 && _props$row5.so_period ? _vm.formatDate((_props$row6 = props.row) === null || _props$row6 === void 0 ? void 0 : _props$row6.so_period) : '-') + " ")]), _c('td', {
          attrs: {
            "clas": props.tdClass
          }
        }, [((_props$row7 = props.row) === null || _props$row7 === void 0 ? void 0 : _props$row7.offer_type) == 1 ? _c('div', [_c('span', {
          staticClass: "text-blue-600 p-1 rounded-lg text-sm font-normal bg-blue-100 text-center"
        }, [_vm._v("Single")])]) : _vm._e(), ((_props$row8 = props.row) === null || _props$row8 === void 0 ? void 0 : _props$row8.offer_type) == 2 ? _c('div', [_c('span', {
          staticClass: "text-gray-600 p-1 rounded-lg text-sm font-normal bg-gray-100 text-center"
        }, [_vm._v("Subscription")])]) : _vm._e(), ((_props$row9 = props.row) === null || _props$row9 === void 0 ? void 0 : _props$row9.offer_type) == 3 ? _c('div', [_c('span', {
          staticClass: "text-yellow-600 p-1 rounded-lg text-sm font-normal bg-yellow-100 text-center"
        }, [_vm._v("Bundle")])]) : _vm._e(), ((_props$row10 = props.row) === null || _props$row10 === void 0 ? void 0 : _props$row10.offer_type) == 4 ? _c('div', [_c('span', {
          staticClass: "text-purple-600 p-1 rounded-lg text-sm font-normal bg-purple-100 text-center"
        }, [_vm._v("Buffet")])]) : _vm._e()]), _c('td', {
          staticClass: "capitalize",
          class: props.tdClass
        }, [((_props$row11 = props.row) === null || _props$row11 === void 0 ? void 0 : _props$row11.status_so) === 200 ? _c('span', {
          staticClass: "text-green-600 p-1 rounded-lg text-sm font-normal bg-green-100 text-center"
        }, [_vm._v(" succeed ")]) : _c('span', {
          staticClass: "text-red-600 p-1 rounded-lg text-sm font-normal bg-red-100 text-center"
        }, [_vm._v("failed")])]), _c('td', {
          attrs: {
            "clas": props.tdClass
          }
        }, [props.row.attempt === 0 ? _c('div', {
          staticStyle: {
            "width": "250px"
          }
        }, [_vm._v(" Waiting for currency ")]) : _c('div', {
          staticStyle: {
            "width": "360px"
          }
        }, [_vm._v(" " + _vm._s((_props$row12 = props.row) !== null && _props$row12 !== void 0 && _props$row12.status_message ? (_props$row13 = props.row) === null || _props$row13 === void 0 ? void 0 : _props$row13.status_message : '-') + " ")])]), _c('td', {
          staticClass: "cursor-pointer text-gray-500 text-left",
          class: props.tdClass
        }, [_c('span', [_vm._v(_vm._s(_vm.formatDateTime(props.row.created).date))]), _c('br'), _c('span', {
          staticClass: "italic text-xs"
        }, [_vm._v(_vm._s(_vm.formatDateTime(props.row.created).time))])]), _c('td', {
          staticClass: "cursor-pointer text-gray-500 text-left",
          class: props.tdClass
        }, [_c('span', [_vm._v(_vm._s(_vm.formatDateTime(props.row.modified).date))]), _c('br'), _c('span', {
          staticClass: "italic text-xs"
        }, [_vm._v(_vm._s(_vm.formatDateTime(props.row.modified).time))])]), _c('td', {
          staticClass: "cursor-pointer text-gray-500 text-left",
          class: props.tdClass
        }, [((_props$row14 = props.row) === null || _props$row14 === void 0 ? void 0 : _props$row14.status_so) !== 200 && ((_props$row15 = props.row) === null || _props$row15 === void 0 ? void 0 : _props$row15.attempt) !== 0 ? _c('button', {
          staticClass: "m-2 bg-blue-600 text-white rounded-lg px-2 py-1.5 text-xs font-semibold",
          attrs: {
            "split": "",
            "split-variant": "outline-primary",
            "variant": "primary",
            "text": "actions"
          },
          on: {
            "click": function ($event) {
              return _vm.resendSO(props.row);
            }
          }
        }, [_vm._v(" Resend ")]) : _vm._e()])])];
      }
    }], null, true)
  }), _vm.totalRows / _vm.perPage > 1 ? _c('div', {
    staticClass: "flex justify-between ml-1 items-center my-2 mx-3"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(_vm.perPage) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-0"
  }, [_c('t-pagination', {
    staticClass: "rounded-lg",
    attrs: {
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }